import React from 'react';

export default class VendorDomoReport extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <div className='contentwrapper'>
        <div className='contentheader'>
          <iframe
            title='Vendor Dashboard'
            src='https://embed.domo.com/embed/pages/5Rvl8'
            width='1248'
            height='1620'
            className='report-frame'
          />
        </div>
      </div>
    );
  }
}
